import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { fadeUp, staggerContainer, viewportOnce } from "../common/Motion";

const BusinessGrowth = () => {
  const reduceMotion = useReducedMotion();
  return (
  <section className="trust-strip" aria-label="Visiosol AI-first value proposition">
    <motion.div className="site-shell trust-grid" variants={reduceMotion ? undefined : staggerContainer} initial={reduceMotion ? false : "hidden"} whileInView="visible" viewport={viewportOnce}>
      <motion.p variants={fadeUp}>AI-first, outcome-led, enterprise-ready</motion.p>
      <motion.div variants={fadeUp}><strong>Grounded intelligence</strong><span>AI connected to trusted business context</span></motion.div>
      <motion.div variants={fadeUp}><strong>Human in control</strong><span>Clear oversight for important decisions</span></motion.div>
      <motion.div variants={fadeUp}><strong>Built to operate</strong><span>Secure systems beyond the prototype</span></motion.div>
    </motion.div>
  </section>
  );
};
export default BusinessGrowth;
